import BackLink from '@components/BackLink'
import PageLoader from '@components/PageLoader'
import { useEvents, useTrip } from '@hooks'
import React from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { LoadingContainer, PageContainer, PageHeader, PageTitle } from './TripMapPage.styles'
import TripMapView from './TripMapView'
import { ErrorNote } from '@components/Notice'

/** The member full map at `/trips/:tripId/map`: the shared map view in the app shell, back to the itinerary. */
const TripMapPage: React.FC = () => {
	const { tripId } = useParams<{ tripId: string }>()
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()
	const { data: trip, isLoading: tripLoading, error: tripError } = useTrip(tripId)
	const { data: eventsData, isLoading: eventsLoading, error: eventsError } = useEvents(tripId)

	if (tripLoading || eventsLoading) {
		return <PageLoader label="Loading map…" />
	}

	if (tripError || eventsError) {
		return <ErrorNote>Error loading map: {tripError?.message || eventsError?.message}</ErrorNote>
	}

	if (!trip) {
		return <LoadingContainer>Trip not found</LoadingContainer>
	}

	return (
		<PageContainer>
			<PageHeader>
				<BackLink path={`/trips/${tripId}/itinerary`} label="Itinerary" />
				<PageTitle>Trip Map</PageTitle>
			</PageHeader>
			<TripMapView
				trip={trip}
				events={eventsData?.events}
				dayParam={searchParams.get('day')}
				emptyDescription="Add a location to an event in your itinerary and it will show up here."
				onBackToItinerary={() => navigate(`/trips/${tripId}/itinerary`)}
			/>
		</PageContainer>
	)
}

export default TripMapPage
